<template>
	<div class="dt-companies-filter-item flex max-w-[192px] flex-col">
		<el-dropdown popper-class="dt-companies-dropdown-filter" trigger="click" :hide-on-click="false" placement="bottom-start">
			<span class="el-dropdown-link flex h-10 w-full items-center gap-x-2 rounded-[5px] border border-solid border-dark_cyan px-3 py-1.5 font-roboto font-medium text-night_rider">
				<span class="block flex-1 truncate">
					<small v-if="filter.selectedCountries.length"> {{ filter.selectedCountries.length }} </small>
					Headquarters Location
				</span>
				<el-icon class="el-icon--right !ml-0">
					<arrow-down />
				</el-icon>
			</span>
			<template #dropdown>
				<el-dropdown-menu>
					<el-dropdown-item>
						<div class="dropdown-search">
							<el-input v-model="countrySearch" @input="filterCountries" placeholder="Search">
								<template #prefix>
									<el-icon>
										<SearchIcon />
									</el-icon>
								</template>
							</el-input>
						</div>
					</el-dropdown-item>
					<el-dropdown-item class="d-flex flex-column align-items-start dropdown-search-item">
						<el-checkbox-group v-model="filter.selectedCountries" @change="onChange()" :max="3">
							<el-checkbox v-for="country in countriesFilter" :key="country.id" :label="country.name" :value="country.id" />
						</el-checkbox-group>
					</el-dropdown-item>
				</el-dropdown-menu>
			</template>
		</el-dropdown>
	</div>
</template>

<script setup lang="js">
import SearchIcon from "@/components/Svg/SearchIcon.vue";
import filter from "@/pages/Company/filter";
import { ArrowDown } from "@element-plus/icons-vue";
import { onMounted, ref } from "vue";

const props = defineProps({
	countries: { type: Array },
});

const countrySearch = ref("");
const countriesFilter = ref("");

const selectedCountries = ref([]);

const onChange = () => {
	filter.value.reload++;
};

const filterCountries = () => {
	// Implement country filtering logic here
	const searchTerm = countrySearch.value.toLowerCase();

	if (searchTerm === "") {
		countriesFilter.value = props.countries;
		return;
	}
	countriesFilter.value = props.countries.filter((country) => country.name.toLowerCase().includes(searchTerm));
};

onMounted(() => {
	countriesFilter.value = props.countries;
});
</script>
